module.exports = __webpack_public_path__ + "static/media/microblading.4be0c494.jpg";